import { PATH_NAME } from 'configs';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';

import { authSelector } from 'store/modules/auth';

import { Loading, LoadingProps } from 'components/molecules';

import { useRouter } from 'hooks/common';

export type AuthRouteGuardProps = {} & Pick<LoadingProps, 'minH'>;
export const AuthRouteGuard: FC<AuthRouteGuardProps> = ({ children, minH }) => {
  const auth = useSelector(authSelector);
  const location = useLocation();
  const router = useRouter();
  const fullPath = location.pathname + location.search + location.hash;
  const redirectPath = router.query['redirect'] as string | undefined;

  // only append redirect if not "/"
  const redirectTo =
    fullPath === '/'
      ? PATH_NAME.LOGIN
      : `${PATH_NAME.LOGIN}?redirect=${encodeURIComponent(redirectPath || fullPath)}`;

  if (auth.init) return <Loading h="100%" loading tip="Authenticating..." minH={minH} />;

  if (!auth.init && !auth.isAuthenticated) return <Redirect to={redirectTo} />;

  return <> {children} </>;
};
